<script>
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import { fetchFaqType, createFaqType, updateFaqType } from '@apis/admin/cs'
import LangItem from '@components/admin/lang-input'

export default {
  components: { LangItem },
  props: {
    type_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {},
      info: null,
      loading: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadFaqType()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadFaqType() {
      const { type_info } = await fetchFaqType(this.type_seq)
      this.params = defaults(type_info, {
        title: '',
        name: '',
        seq: null,
        regdate: null,
      })
      this.info = type_info
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq ? updateFaqType : createFaqType
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_enroll')
      const success_message = this.params.seq
        ? this.$t('cs_faq_type_info.msg_cs_modify')
        : this.$t('cs_faq_type_info.msg_cs_register')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
  },
}
</script>

<template>
  <form
    v-loading="loading"
    action="./"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="20%" />
        <col width="30%" />
        <col width="20%" />
        <col width="30%" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('cs_faq_type_info.cs_type') }}</div></th
          >
          <td><LangItem v-if="!loading" v-model="params.title"></LangItem></td>
          <th scope="row"
            ><div>{{ $t('cs_faq_type_info.cs_type_name') }}</div></th
          >
          <td>
            <template v-if="params.seq">{{ params.name }}</template>
            <input
              v-else
              v-model="params.name"
              type="text"
              :class="[$style.inputTypeText]"
          /></td>
        </tr>
        <tr>
          <th colspan="4" :class="$style.button">
            <span :class="[$style.button, $style.black]"
              ><input
                type="submit"
                :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
            /></span>
          </th>
        </tr>
      </tbody>
    </table>
  </form>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
